import { render, staticRenderFns } from "./FavouritesSearch.vue?vue&type=template&id=86e0cac6&scoped=true&"
import script from "./FavouritesSearch.vue?vue&type=script&lang=js&"
export * from "./FavouritesSearch.vue?vue&type=script&lang=js&"
import style0 from "./FavouritesSearch.vue?vue&type=style&index=0&id=86e0cac6&prod&scoped=true&lang=css&"
import style1 from "./FavouritesSearch.vue?vue&type=style&index=1&id=86e0cac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e0cac6",
  null
  
)

export default component.exports